import React from 'react';
import './Error404.scss';
// import logo from './img/logo.svg';
import error from './img/error.svg';
import Button from 'components/Button/Button';

export default function Error404() {
  return (
    <div className="error-404">
      <div className="error-404__inner">
        {/* <img
          className="error-404__logo"
          src={logo}
          alt="logotipo Estudologia"
        /> */}
        <img className="error-404__img" src={error} alt="imagem de erro" />

        <h1 className="error-404__title">Essa não!</h1>
        <p className="error-404__description">Pedimos desculpas pois não conseguimos encontrar a página que você estava procurando.</p>

        <Button modifiers={['outline']} anchor to="/">
          Voltar para plataforma
        </Button>
      </div>
    </div>
  );
}
